import { useEffect, useState } from 'react'
import '../asset/main.css'
import Upload from 'remixicon-react/AddCircleFillIcon'
import Point from 'remixicon-react/CodeLineIcon'
import MoreIcon from 'remixicon-react/MoreFillIcon'
import { useSpring, animated } from 'react-spring';
import AddMem from "../components/boxAddMemory"
import avatar from '../asset/images/avatar.jpg'
import PtCG from '../asset/images/phuotthuCangio.jpg'
import PtCG2 from '../asset/images/phuotthuCanGio2.jpg'
import PtCG3 from '../asset/images/phuotthuCangio3.jpg'
import Sv from '../asset/images/aesv.jpg'

import canhcut from '../asset/gif/canhcut.gif'
import cat from '../asset/gif/cat.gif'
import cat2 from '../asset/gif/cat2.gif'
import cu from '../asset/gif/cu.gif'
import dog from '../asset/gif/dog.gif'
import duck from '../asset/gif/duck.gif'
import fish from '../asset/gif/fish.gif'
import go2 from '../asset/gif/go2.gif'
import panda from '../asset/gif/panda.gif'
import rabit from '../asset/gif/rabit.gif'

import { getAllMemory } from '../firebase'
import { useDarkMode } from '../DarkModeContext'


export default function Memory() {

    const { darkMode, toggleDarkMode } = useDarkMode();

    const [isShowAddBox, setIsShowAddBox] = useState(false)
    const [listMemory, setListMemory] = useState()
    const springCustom1 = useSpring({

        opacity: isShowAddBox ? 1 : 0,
        transform: isShowAddBox ? 'translateY(0)' : 'translateY(20px)',
    });

    const arrayAnimal = [canhcut, cat, cat2, cu, dog, duck, fish, go2, panda, rabit]


    const random = Math.random(0, 9)
    const animal = arrayAnimal[Math.floor(random * 10)]

    useEffect(() => {
        const fetchData = async () => {
            try {
                const memories = await getAllMemory();
                setListMemory(memories)
                console.log(memories)

            } catch (error) {
                console.error("Error at Memory: ", error)
            }
        }

        fetchData()
    }, [])

    const hideAddBox = () => {
        setIsShowAddBox(false)
    }
    const handleShow = () => {
        setIsShowAddBox(true)
    }

    return (

        <div className="memory">

            <div className="wrap-button-addmem">
                <div className="option-image_buttonup-mem" onClick={handleShow} >
                    <Upload color='#585858' size={34} ></Upload>
                </div>
            </div>


            {
                isShowAddBox ? (<div className="cover-main-mem">
                </div>) : (<></>)
            }
            {isShowAddBox ? (
                <div className="wrap-box-addmem">
                    <animated.div className="animated-class" style={springCustom1}>
                        <div className="wrap-addmembox">
                            <AddMem onHideBox={hideAddBox} className="box-add-mem_main"></AddMem>
                        </div>
                    </animated.div>
                </div>
            ) : <div></div>}

            <div className="memory-wraplist">
                {
                    listMemory ? (
                        listMemory.map((memory, index) => (
                            <div className="sub-mem" key={index}>
                                <div className={darkMode ? "sub-mem_wrap-dark" : "sub-mem_wrap"}>
                                    <div className="submem-post_header">
                                        <div className="post_header-left">

                                            <div className="post_header-avatar">
                                                <img src={avatar} alt="" />
                                            </div>

                                            <div className="post_header-wrap_infopost">
                                                <div className="post_header-name">
                                                    <h1>Author</h1>
                                                </div>
                                                {/* <div className="post_header-cirle-icon">
                                                    <Point size={30}></Point>
                                                </div> */}

                                                <div className="post_header-date">
                                                    <p>{memory.date}</p>
                                                </div>
                                            </div>

                                        </div>


                                    </div>

                                    <div className="submem-post_body">
                                        <div className="post_body-title">
                                            <h2>{memory.title}</h2>
                                        </div>

                                        <div className="post_body-content-wrap">
                                            <div className="wrap-content-post-body">
                                                <div className="post_body-content">
                                                    <p>{memory.content}</p>
                                                </div>
                                                <img src={animal} alt="" />
                                            </div>


                                        </div>
                                    </div>
                                    
                                </div>
                                <div className="post_body-image">
                                        {
                                            memory ? (<img src={memory.avatarProject} alt="" />) : (<div className="loading-indicator-container">
                                                <div className="loading-indicator"></div>
                                            </div>)
                                        }

                                    </div>
                            </div>
                        ))
                    ) : (<div className="loading-indicator-container">
                        <div className="loading-indicator"></div>
                    </div>)
                }


            </div>
        </div>
    )
}